<template>
	 <div id="map"> 	
	 </div>
</template>

<script>

import config from '../../config';
import layerGroups from '../../config/map-layer-groups';
import mapboxgl from 'mapboxgl';
import mapLayersInteractive from '../../config/map-layers-interactive'
import MapboxInspect from 'mapbox-gl-inspect';
import MapCenter from './map-center.vue';
import MapStyle from './map-style.vue';
import MapLegend from './map-legend.vue';
import Vue from 'vue';

var MyComponent = Vue.extend({
	template: '<div class="mapboxgl-ctrl mapboxgl-ctrl-group"><button class="mapboxgl-ctrl-icon" title="debug lines">'+
		'<img src="../img/satelliteThumb.png"/>'+
	'</button></div>'
});

export default {
	name:'mapbox',
	data: function(){
		return {
			mapStyles: config.mapStyles,
			styleCurrent:'satellite',
			curFeatureActive: null, // current feature that is active
			curFeaturesHover: {}, // map of features that are in hover state, key is `${sourceLayer.id}-${layer.id}` 
			featuresVisible:null,
			labelsActive:null,
			labelsHover: null
		};
	},
	computed: {
		deviceType:function(){
			return this.$store.state.device.type;
		},
		poi: function(){
			return this.$store.state.map.poi;
		},
		poiHove: function(){
			return this.$store.state.map.poiHover;
		},
		poiActive: function(){
			return this.$store.state.map.poiActive;
		},
		poiMode: function(){
			return this.$store.state.map.poiMode;
		},
		dimensions: function(){
			return this.$store.state.map.dimensions;
		},
		dimensionsHover: function(){
			return this.$store.state.map.dimensionsHover;
		},
		poiHove: function(){
			return this.$store.state.map.poiHover;
		},
		labelHove: function(){
			return this.$store.state.map.labelHover;
		},
		labelActive: function(){
			return this.$store.state.map.labelActive;
		},
		featureHove: function(){
			return this.$store.state.map.featureHover;
		},
		featureActive: function(){
			return this.$store.state.map.featureActive;
		},
		featureVisibleOn: function(){
			return this.$store.state.map.featureVisibleOn;
		},
		featureVisibleOff: function(){
			return this.$store.state.map.featureVisibleOff;
		},
		featureVisibleClear: function(){
			return this.$store.state.map.featureVisibleClear;
		},
		featureQuery: function(){
			return this.$store.state.map.featureQuery;
		},
		flyTo: function(){
			return this.$store.state.map.flyTo;
		},
		fitBounds: function(){
			return this.$store.state.map.fitBounds;
		},
		layerGroupsVisible: function(){
			return this.$store.state.map.layerGroupsVisible;
		},
		mapActivePoint: function(){
			return this.$store.getters.mapActivePoint;
		},
		mapLeftMargin: function(){
			return this.$store.state.map.leftMargin;
		},
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		},
		mapParams: function(){
			return this.$store.state.map.params;
		}
	},
	props: {
		position:{ // inital map position
			type:Object
		}
	},
	watch:{
		
		poi: function(newFeatures, oldFeatures){
			return this.poiWatch(newFeatures);
		},
		poiHove: function(newFeatures, oldFeatures){
			return this.poiHoverWatch(newFeatures);
		},
		poiActive: function(newFeature, oldFeature){
			return this.poiActiveWatch(newFeature);
		},
		dimensions: function(newDimensions, oldDimensions){
			return this.dimensionsWatch(newDimensions);
		},
		labelHove: function(newFeatures, oldFeatures){
			return this.labelHoverWatch(newFeatures);
		},
		labelActive: function(newFeature, oldFeature){
			return this.labelActiveWatch(newFeature);
		},
		featureHove: function(newFeatures, oldFeatures){
			return this.featuresHoverSet(newFeatures);
		},
		featureActive: function(newFeature, oldFeature){
			return this.featureActiveSet(newFeature);
		},
		featureVisibleOn: function(newFeature, oldFeature){
			return this.featureVisibleOnWatch(newFeature);
		},
		featureVisibleOff: function(newFeature, oldFeature){
			return this.featureVisibleOffWatch(newFeature);
		},
		featureVisibleClear: function(newFeature, oldFeature){
			return this.featureVisibleClearWatch(newFeature);
		},
		featureQuery: function(newQuery, oldQuery){
			return this.featureQueryWatch(newQuery);
		},
		layerGroupsVisible: function(newLayerGroups, oldLayerGroups){
			return this.layerGroupsVisibleWatch(newLayerGroups, oldLayerGroups);
		},
		flyTo: function(newFlyTo, oldFlyTo){
			return this.zoomFlyTo(newFlyTo);
		},
		fitBounds: function(newFitBounds, oldFitBounds){
			return this.zoomFitBounds(newFitBounds);
		},
		mapActivePoint:function(newPoint,oldPoint){
			if (newPoint !== oldPoint) this.activePoint(newPoint);
		},
		mapParams:function(newParams,oldParams){
			if (oldParams && JSON.stringify(newParams) === JSON.stringify(oldParams)) return;
			if (!oldParams || oldParams.style !== newParams.style){
				this.mapStyleChange(this.$data.mapStyles[newParams.style]);
			}
		}
	},
	mounted: function(){
		mapboxgl.accessToken = config.mapbox.accessToken;

		let mapData = {
			container: 'map',
			attributionControl:false,
			minZoom: 3,
			maxZoom: 21
		};

		let style = 'vector'; // initial map style

		if (this.mapParams){
			if (this.mapParams.lng !== null && this.mapParams.lat !== null) mapData.center = [this.mapParams.lng,this.mapParams.lat];
			if (this.mapParams.zoom) mapData.zoom = this.mapParams.zoom;
			if (this.mapParams.pitch) mapData.pitch = this.mapParams.pitch;
			if (this.mapParams.bearing) mapData.bearing = this.mapParams.bearing;
			if (this.mapParams.style) style = this.mapParams.style;
		}

		mapData.style = this.$data.mapStyles[style];

		this.map = new mapboxgl.Map(mapData);
		this.controlsAdd();
		this.map.on('load', ()=>{
			this.mapReady();
		});
	},
	methods: {
		activePoint:function(point){

			if (this.clickMarker) this.clickMarker.remove();
			if (point === null) return;

			let el = document.createElement('div');
			el.innerHTML = '';
			el.className = 'marker icon-crosshair-active';
			this.clickMarker = new mapboxgl.Marker(el,{offset:[0,0]})
				.setLngLat(point)
				.addTo(this.map);

			const features = this.featuresInteractiveGet(this.map.project(point));

			if (features.length === 1){ // if only one feature, go to the feature page 
				const feature = features[0];
				if (feature.properties.route){ // if the feature has a route defined
					this.$router.replace(JSON.parse(feature.properties.route));
					return;
				}

				const styleLayer = feature.layer.id;
				if (!mapLayersInteractive[styleLayer] || !mapLayersInteractive[styleLayer].route) return; // if route doesn't exist exit
				const layerDefinition = mapLayersInteractive[styleLayer]
				let resourceId = feature.id;
				if (feature.properties.resource_id) resourceId = feature.properties.resource_id; // if resource id exists override 
				let params = {}
				if (layerDefinition.routeParam){
					params[layerDefinition.routeParam] = feature.properties[layerDefinition.routeParam]
				} else if(resourceId) {
					params.id = resourceId
				}
				this.$router.replace({
					name:layerDefinition.route,
					params,
				});
			} else {
				// pass around feature representations but not the real features in order to avoid a vuex error of mutating state outside mutation handler

				this.$store.dispatch('MAP_ACTIVE_POINT_FEATURES_SET', {
					features: this.mapFeaturesToStoreFeatures(features)
				});
			}
		},


		controlsAdd:function(){
			const me = this;
			class MapCenterControl {
				onAdd(map) {
					this._container = document.createElement('div');

					let compClass = Vue.extend(MapCenter);

					let comp = new compClass({
						router:me.$router,
						store:me.$store,
						propsData:{}
					}).$mount();

					this._container.appendChild(comp.$el);

					return this._container;
				}
				onRemove() {
					this._container.parentNode.removeChild(this._container);
					this._map = undefined;
				}
			}
			class MapStyleControl {
				onAdd(map) {
					this._container = document.createElement('div');

					let compClass = Vue.extend(MapStyle);

					let comp = new compClass({
						router:me.$router,
						store:me.$store,
						propsData:{}
					}).$mount();

					this._container.appendChild(comp.$el);

					return this._container;
				}
				onRemove() {
					this._container.parentNode.removeChild(this._container);
					this._map = undefined;
				}
			}
			class MapLegendControl {
				onAdd(map) {
					this._container = document.createElement('div');

					let compClass = Vue.extend(MapLegend);

					let comp = new compClass({
						router:me.$router,
						store:me.$store,
						propsData:{}
					}).$mount();

					this._container.appendChild(comp.$el);

					return this._container;
				}
				onRemove() {
					this._container.parentNode.removeChild(this._container);
					this._map = undefined;
				}
			}

			if (this.deviceType !== 'mobile'){ // if not on mobile, add zoom controls
				this.map.addControl(new mapboxgl.NavigationControl({showCompass: false}), 'top-right');
			}

			//  compact attribution
			this.map.addControl(new mapboxgl.AttributionControl({compact: false}),'bottom-right');
			this.map.addControl(new MapStyleControl({}));
			//this.map.addControl(new MapLegendControl({}), 'bottom-right');

			if (this.deviceType === 'mobile'){
				this.map.addControl(new MapCenterControl({}));
			}
		},

		featureActiveClear: function(){
			if (this.curFeatureActive){
				this.map.setFeatureState(this.curFeatureActive, {state:'base'}); // remove active state from previous feature
				this.featureStateSetSourceGroup(this.curFeatureActive, 'base');
			}
		},

		featureGetKey: function(feature){
			return `${feature.sourceLayer}-${feature.id}`;
		},

		featureStateSet: function(feature, state){
			if (feature.id === undefined && feature.properties){

				let filter = ['all'];
				for (let i in feature.properties){
					filter.push(['==',['get',i],feature.properties[i]]);
				}
				
				const features = this.map.querySourceFeatures('scoutred',{
					source:feature.source,
					sourceLayer:feature.sourceLayer,
					filter:filter
				});

				if (!features || features.length < 1) return;
				feature.id = features[0].id;
			}
			const featureState = this.map.getFeatureState(feature);

			if (!featureState || featureState.state === 'active') return; // if feature state is already active, don't change it

			if (state === 'active'){
				if (this.curFeatureActive){
					this.map.setFeatureState(this.curFeatureActive, {state:'base'}); // remove active state from previous feature
					this.featureStateSetSourceGroup(this.curFeatureActive, 'base');
				}
				this.map.setFeatureState(feature, {state:'active'});
				this.featureStateSetSourceGroup(feature, 'active');
				this.curFeatureActive = feature;
				return;
			}

			this.map.setFeatureState(feature, {state});
			this.featureStateSetSourceGroup(feature, state);
		},

		featureStateSetSourceGroup: function(feature, state){
			if (!feature.layer || !mapLayersInteractive[feature.layer.id] || !mapLayersInteractive[feature.layer.id].sourceGroup) return;

			// iterate group and set feature state for all in group
			mapLayersInteractive[feature.layer.id].sourceGroup.forEach((g)=>{
				const feat = {
					id: feature.id,
					source: feature.source,
					sourceLayer: g
				};
				this.map.setFeatureState(feat, {state});
			});
		},

		featuresGetMapFromAry: function(features = []){
			let map = {};
			features.forEach((feature)=>{
				map[this.featureGetKey(feature)] = feature;
			});
			return map;
		},

		featuresDiff: function(current = {}, proposed = {}){
			let diff = {add:[], remove:[]};

			for (let i in current){
				if (!proposed[i]) diff.remove.push(current[i]);
			}
			for (let i in proposed){
				if (!current[i]) diff.add.push(proposed[i]);
			}
			return diff;
		},

		featuresHoverSet: function(features = []){
			if (features === null) features = [];

			const proposed = this.featuresGetMapFromAry(features);
			const diff = this.featuresDiff(this.curFeaturesHover, proposed);
			this.curFeaturesHover = proposed;

			diff.add.forEach((feature)=>{
				this.featureStateSet(feature, 'hover');
			});
			diff.remove.forEach((feature)=>{
				this.featureStateSet(feature, 'base');
			});
		},

		featureActiveSet: function(feature){
			if (feature === null) return this.featureActiveClear();
			this.featureStateSet(feature, 'active');
		},

		featuresInteractiveGet: function(point){
			//check what feature user is over

			const zoom = this.mapParams.zoom;

			const margin = 2;
			const bbox = [
				{x:point.x-margin,y:point.y+margin},
				{x:point.x+margin,y:point.y-margin}
			];
			let layers = [];
			if (this.poiMode){
				layers = ['poi']
			} else {
				for (let id in mapLayersInteractive){
					if (mapLayersInteractive[id].zoom){
						const zoomReq = mapLayersInteractive[id].zoom;
						if (zoom < zoomReq[0] || zoom >= zoomReq[1]) continue;
					}
					layers.push(id);
				}
			}
			const options = {
				layers
			}
			const features = this.map.queryRenderedFeatures(bbox, options);
			if (!features) return [];

			// remove dupes and invisible features
			let used = [], priority = [];
			const interactive = features.filter(feature => {
				if (feature.properties.noFeatureResult) return false;
				const key = feature.layer.id+'-'+feature.id;
				if (used.indexOf(key) !== -1) return false; // already have this feature
				used.push(key);

				const interactiveDef = mapLayersInteractive[feature.layer.id];
				if (interactiveDef.priority){
					priority.push(feature);
				}
				if (!interactiveDef.state) return true;

				for (let i in interactiveDef.state){
					if (interactiveDef.state[i] !== feature.state[i]) return false;
				}

				return true;
			});

			if (priority.length > 0) return priority;

			return interactive;
		},

		mapFeaturesToStoreFeatures: function(features){
			if (!features) return null;
			return features.map((feature)=>{
				return {
					id: feature.id,
					layer: {id: feature.layer.id},
					properties: {... feature.properties},
					source: feature.source,
					sourceLayer: feature.sourceLayer,
					type: feature.type,
				};
			});
		},

		featureVisibleOnWatch:function(features){
			if (!features) return;

			this.featuresVisible = this.featuresVisible || [];

			features.map((feature)=>{
				if (!feature.featureId){
					let filter = ['all'];
					for (let i in feature.properties){
						filter.push(['==',['get',i],feature.properties[i]]);
					}
					
					const feats = this.map.querySourceFeatures('scoutred',{
						sourceLayer:feature.sourceLayer,
						filter:filter
					});
					let visible = [];
					feats.map((feat)=>{
						this.map.setFeatureState({source:'scoutred',sourceLayer:feature.sourceLayer, id: feat.id}, 
							{visible:'on'});
						visible.push({...feature,featureId:feat.id});
					});
					this.featuresVisible = [...this.featuresVisible, ...visible];
					return;
				}

				// remove state from previously active features
				this.map.setFeatureState({source:'scoutred',sourceLayer:feature.sourceLayer, id: feature.featureId}, 
					{visible:'on'});
				this.featuresVisible = [...this.featuresVisible,feature];
			});
		},
		featureVisibleOffWatch:function(features){
			if (!features) return;

    		features.map((feature)=>{
				if (!feature.featureId){
					let filter = ['all'];
					for (let i in feature.properties){
						filter.push(['==',['get',i],feature.properties[i]]);
					}
					const features = this.map.querySourceFeatures('scoutred',{
						sourceLayer:feature.sourceLayer,
						filter:filter
					});
					let visible = (this.featuresVisible)? [...this.featuresVisible]: [];
					features.map((feat)=>{
						this.map.setFeatureState({source:'scoutred',sourceLayer:feature.sourceLayer, id: feat.id}, 
							{visible:null});
						visible.filter((f)=>{
							if (f.featureId === feat.featureId && f.sourceLayer === feature.sourceLayer) return false;
							return true;
						});
					});
					this.featuresVisible = visible;
					return;
				}

				// remove state from previously active features
				this.map.setFeatureState({source:'scoutred',sourceLayer:feature.sourceLayer, id: feature.featureId}, 
					{visible:null});

				if (this.featuresVisible){
					let visible = [...this.featuresVisible];
					visible.filter((feat)=>{
						if (feat.featureId === feature.featureId && feat.sourceLayer === feature.sourceLayer) return false;
						return true;
					});
					this.featuresVisible = visible;
				}
			});
		},
		featureVisibleClearWatch:function(clear){
			if (clear === 'all' && this.featuresVisible){
				this.featuresVisible.map((feat)=>{
					this.map.setFeatureState({source:'scoutred',sourceLayer:feat.sourceLayer, id: feat.featureId}, 
						{visible:null});
				});
				this.featuresVisible = null;
			}
			this.$store.dispatch('MAP_FEATURE_VISIBLE_CLEAR',null);
		},

		layerGroupsVisibleWatch: function(newLayerGroups, prevLayerGroups){

			const hideLayerGroups = prevLayerGroups.filter(group => {
				return !newLayerGroups.includes(group)
			})

			hideLayerGroups.forEach(group =>{
				const layerGroup = layerGroups.find(a => a.name === group);
	    		layerGroup.layers && layerGroup.layers.forEach((layer)=>{
	    			this.map.getLayer(layer) && this.map.setLayoutProperty(layer, 'visibility', 'none');
	    		})
			})

			newLayerGroups.forEach(group => {
				const layerGroup = layerGroups.find(a => a.name === group);
	    		layerGroup.layers && layerGroup.layers.forEach((layer)=>{
	    			this.map.getLayer(layer) && this.map.setLayoutProperty(layer, 'visibility', 'visible');
	    		})
			})
    },

  	layerGroupsVisibleStyleChange: function(){

  		const newLayerGroups = this.layerGroupsVisible;
  		const prevLayerGroups = ['zoning'];

  		this.layerGroupsVisibleWatch(newLayerGroups, prevLayerGroups)
  	},

		mapReady:function(){
			this.setBounds();	
			this.dimensionsWatch(this.dimensions)

			this.map.on('moveend', (e)=>{
				// check if there is an active pt, if so query rendered features on pt
				
				this.setPosition();
				this.setBounds();
			});

			this.map.on('mousemove', (e)=>{
				this.mouseMove(e.point);
			});

			this.map.on('click', (e)=>{
				this.mouseClick(e);
			});

			this.$store.dispatch('MAP_LOADED', true);	
		},

		mouseClick:function(e){
			const coords = this.map.unproject(e.point);

			// if map is in poi mode, only allow user to click on poi
			if (this.poiMode){
				const poi = this.poiNearestGet(e.point)
				if (!poi) return
				if (poi.properties.route){ // if the poi has a route defined
					this.$router.replace(JSON.parse(poi.properties.route));
				}
				return
			}

			this.$router.push({
				name: 'features', 
				params:{
					lng: parseFloat(coords.lng).toFixed(7),
					lat: parseFloat(coords.lat).toFixed(7)
				}
			});
		},

		mouseMove:function(point){

			if (this.mouseMoveProcessing) return

			this.mouseMoveProcessing = true

			setTimeout(()=>{ //throttle the mouse move interaction to once every 50ms
				this.mouseMoveProcessing = false
				const interactive = this.featuresInteractiveGet(point);

				this.featuresHoverSet(interactive);

				if (interactive.length < 1){
					document.getElementById('map').className = 'mapboxgl-map';
					return;
				}

				// iterate features and add hover states
				document.getElementById('map').className = 'mapboxgl-map cursor-crosshair';
				return;

			},50)			

		},

		zoomCalcOffset:function(){
			let centerX = window.innerWidth/2;
			let leftMargin = this.mapLeftMargin || 0;
			let rightW = window.innerWidth - leftMargin;
			let adjustedCenterX = leftMargin+(rightW/2);
			return (adjustedCenterX - centerX) / 2;
		},

		zoomFitBounds: function(fitBounds){
			if (!fitBounds) return;
			const offsetX = this.zoomCalcOffset();
			this.map.fitBounds(fitBounds.bounds.bbox || fitBounds.bounds, {
				offset:[offsetX, 0],
				//	default zoom of 17
				maxZoom: fitBounds.maxZoom ? fitBounds.maxZoom: 17,
				padding: fitBounds.padding ? fitBounds.padding: 30,
			});

			if (fitBounds.minZoom){
				const fitDone = ()=>{
					const curZoom = this.map.getZoom();
					if (curZoom < fitBounds.minZoom){
						this.map.zoomTo(fitBounds.minZoom);
					}

					this.map.off('moveend',fitDone);

					let loadedInt = setInterval(()=>{
						if (this.map.areTilesLoaded()){
							this.$store.dispatch('MAP_FIT_BOUNDS_DONE');
							clearInterval(loadedInt);
						}
					},100);
				};

				// on completion check current zoom, if under min, zoom to min
				this.map.on('moveend',fitDone);
			}
		},

		zoomFlyTo: function(flyTo){
			const offsetX = this.zoomCalcOffset();
			this.map.flyTo({
				center: flyTo.center, 
				zoom: flyTo.zoom,
				offset: [offsetX,0]
			});
			const flyToDone = ()=>{
				this.map.off('moveend',flyToDone);
				let loadedInt = setInterval(()=>{
					if (this.map.areTilesLoaded()){
						this.$store.dispatch('MAP_FLY_TO_DONE');
						clearInterval(loadedInt);
					}
				},100);
			};

			// on completion check current zoom, if under min, zoom to min
			this.map.on('moveend',flyToDone);
		},

		mapStyleChange:function(style){
			this.map.setStyle(style);
			let checkInterval = setInterval(()=>{
				if (!this.map.isStyleLoaded()) return;
				clearInterval(checkInterval);
				this.poiWatch(this.poi);
				this.dimensionsWatch(this.dimensions)
				this.layerGroupsVisibleStyleChange();
			},50)
		},
		
		poiWatch:function(features){
			let poi = [];

			if (features && features.map) features.map((feature)=>{
				poi.push({
					type: "Feature",
					id: feature.id,
					geometry: feature.geometry,
					properties: feature.properties
				});
			});		

			if (this.map.getSource('poi')) this.map.getSource('poi').setData({
				"type": "FeatureCollection",
				"features": poi
			});

			let exists = [];
			let poiIcons = poi.filter((point)=>{
				const key = `${point.geometry.coordinates[0]}-${point.geometry.coordinates[1]}`
				if (exists.indexOf(key) === -1){
					exists.push(key);
					return true;
				}
				return false;
			});

			if (this.map.getSource('poi-icon')) this.map.getSource('poi-icon').setData({
				"type": "FeatureCollection",
				"features": poiIcons
			});
		},

		poiNearestGet:function(point){
			const zoom = this.mapParams.zoom;

			const margin = 2;
			const bbox = [
				{x:point.x-margin,y:point.y+margin},
				{x:point.x+margin,y:point.y-margin}
			];
			const layers = ['poi'];
			const options = {
				layers
			}
			const features = this.map.queryRenderedFeatures(bbox, options);
			if (!features) return [];
			return features[0]
		},

		dimensionsWatch:function(geojson){
			if (this.map.getSource('dimensions')){
				if (geojson === null){
					this.map.getSource('dimensions').setData({
					  "type": "FeatureCollection",
					  "features":[]
					});
				} else {
					this.map.getSource('dimensions').setData(geojson);
				}
				
			}
		},
		
		setPosition: function(){
			const center = this.map.getCenter();
			const zoom = this.map.getZoom();
			const pitch = this.map.getPitch();
			const bearing = this.map.getBearing();
			
			this.$store.dispatch('MAP_PARAMS_SET', {
				lat:center.lat,
				lng:center.lng,
				zoom,
				pitch,
				bearing
			});	
		},
		setBounds: function(){
			let b = this.map.getBounds();
				
			// subtract bounds by left margin
			let leftMargin = this.mapLeftMargin || 0;
			let newPt = {x:leftMargin,y:window.innerHeight};
			let newSw = this.map.unproject(newPt);

			b._sw = newSw;

			this.$store.dispatch('MAP_BOUNDS_SET', {
				bounds: b
			});			
		}
	}
}
</script>
<style>
#map {
	position:fixed; 
	top:0; 
	bottom:0;
	width:100%;
}

a.mapboxgl-ctrl-logo {
	display:none;
}

.mobile .mapboxgl-ctrl-top-right{
	top:54px;
}

.mobile .mapboxgl-ctrl-group > button{
	width:34px;height:34px;
}

.cursor-crosshair .mapboxgl-canvas-container{ cursor:url('../../assets/img/icon-crosshair.svg') 15 15, auto !important;}

.cursor-pointer .mapboxgl-canvas-container{ cursor:pointer !important;}

.marker{
	background-size: cover;
	width: 30px;
	height: 30px;
	cursor: pointer;
	text-align:center;
	color:#CC1717;
	line-height:26px;
}

.icon-crosshair-active{
	background-image: url('../../assets/img/icon-crosshair-active.svg');
}
</style>


// WEBPACK FOOTER //
// src/components/map/mapbox.vue